import { AmplitudeEvent } from "@/telemetry/AmplitudeEvent";

export class TeamCreatedEvent extends AmplitudeEvent {
	static TEAM_LIST_LOCATION = "team list";
	static SCHEDULE_VIEW_LOCATION = "schedule view";

	constructor( teamName, creationLocation ) {
		if ( ![ TeamCreatedEvent.TEAM_LIST_LOCATION, TeamCreatedEvent.SCHEDULE_VIEW_LOCATION, ].includes( creationLocation ) ) {
			throw new Error( `invalid creation location: ${creationLocation}` );
		}
		super();
		this.name = "Team Created";
		this.eventProperties.team_name = teamName;
		this.eventProperties.creation_location = creationLocation;
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/TeamCreatedEvent.js